import RedirectToProfileComponent from "./RedirectToProfileComponent";

export default RedirectToProfileComponent;